import LocalizedStrings from 'react-localization';

const localizationStrings = new LocalizedStrings({
  ja: {
    errorTile: 'エラー',
    btnOk: 'OK',
    btnCancel: 'キャンセル',
    errorAmplifyAuthUserNotFoundException: 'User does not exist...', // TODO: Correct error message
  },
});

export { localizationStrings };

type Local = {
  common: {
    error: string;
    ok: string;
    cancel: string;
    yes: string;
    no: string;
    back: string;
    done: string;
    userStatusInCall: string;
    userStatusActive: string;
    userStatusOfferable: string;
    userStatusLogout: string;
    all: string;
    genderMale: string;
    genderFemale: string;
    genderUndefined: string;
    save: string;
    imageCropper: {
      loading: string;
      toolbar: string;
      openCamera: string;
      openAlbum: string;
      reopenCamera: string;
      reopenAlbum: string;
      deleteImage: string;
    };
    delete: string;
    next: string;
    unselected: string;
  };
  error: {
    amplifyAuthUserNotFoundException: string;
    amplifyAuthNotAuthorizedException: string;
    amplifyAuthCodeMismatchException: string;
    amplifyAuthInvalidPasswordException: string;
    amplifyAuthUsernameExistsException: string;
  };
  components: {
    chat: {
      messageInputPlaceholder: string;
    };
    offerListItem: {
      offerAvatar: {
        userStatusLogout: string;
        userStatusOfferable: string;
        userStatusActive: string;
        userStatusInCall: string;
      };
      pv: {
        label: string;
      };
      public: string;
      unpublic: string;
      createdAt: string;
    };
    relatedOffersList: {
      header: string;
    };
    reviewCarousel: {
      showMore: string;
    };
    soundRecorder: {
      deleteAlert: {
        title: string;
      };
    };
  };
  navigation: {
    home: string;
    preOfferChatList: string;
    callHistoryList: string;
    offers: string;
    myPage: string;
    myProfile: string;
    likedService: string;
    blockedUsers: string;
    notifications: string;
    review: string;
    myAccount: string;
    myAccountEmail: string;
    myAccountPassword: string;
    homeFilter: string;
    offerEdit: string;
    callRequest: string;
    callHistory: string;
    salesHistory: string;
    withdrawal: string;
    withdrawalRequest: string;
    withdrawalDescription: string;
    balance: string;
    owner: string;
    myAddress: string;
    creditCard: string;
    identification: string;
    privacyPolicy: string;
    terms: string;
  };
  screens: {
    authLanding: {
      btnSignUp: string;
      btnSignIn: string;
    };
    authPasswordReset: {
      confirmLayout: {
        label: string;
        inputCodePlaceholder: string;
        inputPasswordPlaceholder: string;
        inputPasswordConfirmPlaceholder: string;
        inputCodelValidationRequire: string;
        inputPasswordValidationRequire: string;
        inputPasswordConfirmValidationRequire: string;
        inputPasswordConfirmValidationMismatch: string;
        btnConfirm: string;
        processedDialogTitle: string;
        processedDialogBtnOK: string;
        errorCodeMismatchException: string;
        errorInvalidParameterException: string;
      };
      requestLayout: {
        label: string;
        inputEmailPlaceholder: string;
        inputEmailValidationRequire: string;
        inputEmailValidationFormat: string;
        btnReset: string;
        errorNotAuthorizedException: string;
        errorUserNotFoundException: string;
      };
    };
    authSignIn: {
      navigationBarSignInTitle: string;
      inputEmailPlaceholder: string;
      inputPasswordPlaceholder: string;
      inputEmailValidationRequire: string;
      inputEmailValidationFormat: string;
      inputPasswordValidationRequire: string;
      btnSignIn: string;
      btnRestore: string;
      navigationBarPasswordResetTitle: string;
      errorNotAuthorizedException: string;
    };
    authSignupConfirm: {
      label: string;
      inputCodePlaceholder: string;
      inputCodeValidationRequire: string;
      btnReset: string;
      confirmSuccessAlertTitle: string;
      confirmSuccessAlertDescription: string;
      errorCodeMismatchException: string;
    };
    authSignup: {
      navigationBarSignUpTitle: string;
      inputNicknamePlaceholder: string;
      inputEmailPlaceholder: string;
      inputPasswordPlaceholder: string;
      inputPasswordConfirmPlaceholder: string;
      inputNicknameValidationRequire: string;
      inputEmailValidationRequire: string;
      inputEmailValidationFormat: string;
      inputPasswordValidationRequire: string;
      inputPasswordConfirmValidationRequire: string;
      inputPasswordValidationMismatch: string;
      btnSignUpSendCode: string;
      btnSignUpCancel: string;
      navigationBarConfirmTitle: string;
      errorUsernameExistsException: string;
      errorInvalidParameterException: string;
    };
    balance: {
      buyPointAlertSuccessTitle: string;
      balance: string;
      cardDetail: string;
      usageHistory: string;
      buyPoint: string;
      addCreditCard: string;
      buyPointConfirmAlertTitle: string;
      buyPointConfirmAlertDescription: string;
    };
    blockedUsers: {
      notFound: {
        text: string;
      };
      unblock: string;
    };
    call: {
      talkActions: {
        new: string;
      };
      actions: {
        hide: string;
        abort: string;
        sendAndFinish: string;
        reject: string;
        talk: string;
        finish: string;
      };
      banner: {
        waitingAnswerStatus: string;
        waitingAnswerLabel: string;
        answerRequiredStatus: string;
        answerRequiredLabel: string;
        waitingTalkConnectionBySenderStatus: string;
        waitingTalkConnectionByReceiverStatus: string;
        talkTimeStatus: string;
        talkTimeLabel: string;
        talkRemainStatus: string;
      };
      comment: {
        placeholder: string;
        comment: string;
      };
      talkBlock: {
        description: string;
      };
      waitingAnswerBlock: {
        description: string;
      };
      navigationBarTitle: string;
      callOver: string;
      service: string;
      abortAlertTitle: string;
      abortAlertDescription: string;
    };
    callHistory: {
      requestOfferAlertSuccessTitle: string;
      requestOfferAlertSuccessDescription: string;
      service: string;
      price: string;
      history: string;
      requestStarted: string;
      requestCanceled: string;
      callStarted: string;
      callCanceled: string;
      callFinished: string;
      requestExpired: string;
      cancelReason: string;
      review: string;
      openReview: string;
      chat: string;
      openReoffer: string;
      requestReoffer: string;
      requestReofferAlert: string;
    };
    callHistoryList: {
      callHistoryItem: {
        activeCall: string;
        waitingForReview: string;
      };
      navigationBarTopTitle: string;
      tabAll: string;
      tabSent: string;
      tabReceived: string;
      notFound: string;
    };
    callRequest: {
      price: string;
      balanceExpired: string;
      maxTalkTime: string;
      waitingTime: string;
      commentPlaceholder: string;
      comment: string;
      service: string;
      aboutTalk: string;
      send: string;
      buyPoints: string;
    };
    creditCard: {
      creditCard: string;
      register: string;
    };
    home: {
      notFound: {
        text: string;
        description: string;
      };
      searchBar: {
        search: string;
        placeholder: string;
      };
      navigationBarTopTitle: string;
      recommendations: string;
      searchResults: string;
    };
    homeFilter: {
      userStatus: string;
      category: string;
      gender: string;
      age: string;
      area: string;
      order: string;
      reset: string;
    };
    identification: {
      phone: {
        codeSentAlertTitle: string;
        phone: string;
        phonePlaceholder: string;
        code: string;
        codePlaceholder: string;
        codeSend: string;
        codeResend: string;
      };
      removeImageAlertTitle: string;
      emptyImagesAlertTitle: string;
      imageUpload: string;
    };
    likedServies: {
      notFound: {
        text: string;
      };
    };
    myAccount: {
      email: string;
      emailDescription: string;
      password: string;
    };
    myAccountEmail: {
      confirm: {
        description: string;
        code: string;
      };
      request: {
        emailValidationRequire: string;
        emailValidationFormat: string;
        emailValidationMatch: string;
        email: string;
        emailDescription: string;
      };
      emailChangeAlertTitle: string;
    };
    myAccountPassword: {
      oldPasswordValidationRequired: string;
      passwordValidationRequired: string;
      passwordConfirmValidationRequired: string;
      passwordConfirmValidationMismatch: string;
      password: string;
      oldPassword: string;
      newPassword: string;
      newPasswordConfirm: string;
    };
    myAddress: {
      postnumberValidationRequired: string;
      postnumberValidationFormat: string;
      prefectureValidationRequired: string;
      cityValidationRequired: string;
      addressValidationRequired: string;
      postnumber: string;
      postnumberPlaceholder: string;
      prefecture: string;
      city: string;
      address: string;
      addressPlaceholder: string;
      address2: string;
      address2Placeholder: string;
    };
    myPage: {
      navigationBarTopTitle: string;
      logoutAlertTitle: string;
      logoutAlertDescription: string;
      logoutAlertAction: string;
      profile: string;
      balance: string;
      favorites: string;
      blocks: string;
      salerReview: string;
      salerReviewTitle: string;
      salerReviewNotFound: string;
      buyerReview: string;
      buyerReviewTitle: string;
      buyerReviewNotFound: string;
      salesHistory: string;
      myAccount: string;
      notifications: string;
      feedback: string;
      logout: string;
      removeAccountBtn: string;
      removeAccountAlertTitle: string;
      removeAccountAlertMessage: string;
      removeAccountAlertAction: string;
      privacyPolicy: string;
      terms: string;
    };
    myProfile: {
      aboutProfileControl: {
        description: string;
        title: string;
        placeholder: string;
      };
      aboutTalkControl: {
        description: string;
        title: string;
        placeholder: string;
      };
      address: {
        title: string;
        helper: string;
      };
      birthday: {
        title: string;
        helper: string;
      };
      descriptionControl: {
        description: string;
        title: string;
        placeholder: string;
      };
      genderControl: {
        title: string;
      };
      identification: {
        title: string;
        rejected: string;
        processed: string;
        approved: string;
      };
      nameValidationRequired: string;
      generalSection: string;
      nickname: string;
      nicknamePlaceholder: string;
      nicknameValidationExist: string;
      fullname: string;
      fullnamePlaceholder: string;
      fullnameHelper: string;
      identificationSection: string;
      profileSection: string;
      aboutTalkSection: string;
      descriptionSection: string;
      soundSection: string;
    };
    offer: {
      averageTimeRow: {
        text: string;
      };
      usageCountText: string;
      usageCountSufix: string;
      review: string;
      openPreOfferChat: string;
      openOffer: string;
      block: string;
    };
    offerEdit: {
      name: string;
      namePlaceholder: string;
      category: string;
      price: string;
      publish: string;
      publishActive: string;
      publishInactive: string;
      description: string;
      imagesValidationRequired: string;
      nameValidationRequired: string;
      descriptionValidationRequired: string;
      categoryValidationRequired: string;
      priceValidationRequired: string;
      serviceSection: string;
      descriptionSection: string;
    };
    offers: {
      notFound: {
        text: string;
        description: string;
        action: string;
      };
      navigationBarTopTitle: string;
    };
    owner: {
      blockAlertTitle: string;
      createdAt: string;
      aboutTalk: string;
      aboutProfile: string;
      description: string;
      review: string;
      reviewNotFound: string;
      block: string;
    };
    preOfferChatList: {
      navigationBarTopTitle: string;
      tabAll: string;
      tabSent: string;
      tabReceived: string;
      notFound: string;
    };
    review: {
      commentInput: {
        placeholder: string;
      };
      ratingSection: string;
      post: string;
    };
    reviewByOffer: {
      notFound: {
        text: string;
      };
    };
    reviewByOfferToUser: {
      notFound: {
        text: string;
      };
    };
    salesHistory: {
      notFound: {
        text: string;
      };
      saleRow: {
        withdrawalRequest: string;
        withdrawalProcessing: string;
        withdrawalApproved: string;
        withdrawalError: string;
        withdrawalReject: string;
      };
      amountAlertTitle: string;
      amountAlertDescription: string;
      identificationAlertTitle: string;
      sales: string;
      limit: string;
      withdrawal: string;
      salesAmountDescription: string;
      historySection: string;
    };
    user: {
      blockAlertTitle: string;
      createdAt: string;
      aboutTalk: string;
      aboutProfile: string;
      description: string;
      review: string;
      reviewNotFound: string;
      block: string;
    };
    withdrawal: {
      typeUndefined: string;
      typeRequest: string;
      typeProcessing: string;
      typeApproved: string;
      typeRejected: string;
      typeError: string;
      status: string;
      createdAt: string;
      requestAmount: string;
      fee: string;
      transferAmount: string;
      systemFee: string;
      bankSection: string;
      bankCode: string;
      bankName: string;
      branchCode: string;
      branchName: string;
      accountType: string;
      accountNumber: string;
      accountHolder: string;
    };
    withdrawalRequest: {
      amountControl: {
        text: string;
      };
      bankControl: {
        text: string;
        helper: string;
      };
      bankBranchControl: {
        text: string;
        helper: string;
      };
      accountTypeControl: {
        text: string;
      };
      accountNumberControl: {
        text: string;
        placeholder: string;
      };
      accountHolderControl: {
        text: string;
        placeholder: string;
      };
      amountValidationRequired: string;
      amountValidationUnexpeced: string;
      bankValidationRequired: string;
      branchValidationRequired: string;
      accountTypeValidationRequired: string;
      accountNumberValidationRequired: string;
      accountHolderValidationRequired: string;
      accountHolderValidationFormat: string;
      doneAlertTitle: string;
      sales: string;
      description: string;
      transferSection: string;
      process: string;
    };
  };
};

const local: Local = {
  common: {
    error: 'エラー',
    ok: 'OK',
    cancel: 'キャンセル',
    yes: 'はい',
    no: 'いいえ',
    back: '戻る',
    done: '完了',
    userStatusInCall: '通話中',
    userStatusActive: 'アクティブ',
    userStatusOfferable: 'トーク申込可能',
    userStatusLogout: 'ログアウト',
    all: '全て',
    genderMale: '男性',
    genderFemale: '女性',
    genderUndefined: '指定しない',
    save: '保存',
    imageCropper: {
      loading: '処理中...',
      toolbar: '編集',
      openCamera: 'カメラ撮影する',
      openAlbum: 'アルバムから選ぶ',
      reopenCamera: 'カメラ撮影し直す',
      reopenAlbum: 'アルバムから選び直す',
      deleteImage: '写真を削除する',
    },
    delete: '削除する',
    next: '次へ',
    unselected: '未選択',
  },
  error: {
    amplifyAuthUserNotFoundException: 'ユーザーが存在しません',
    amplifyAuthNotAuthorizedException: '認証失敗',
    amplifyAuthCodeMismatchException: 'コードが正しくありません',
    amplifyAuthInvalidPasswordException: 'パスワードが正しくありません',
    amplifyAuthUsernameExistsException:
      'すでに登録されたメールアドレスです（退会したメールアドレスも登録できません）',
  },
  components: {
    chat: {
      messageInputPlaceholder: 'メッセージを入力してください',
    },
    offerListItem: {
      offerAvatar: {
        userStatusLogout: 'ログアウト',
        userStatusOfferable: 'トーク申込可能',
        userStatusActive: 'アクティブ',
        userStatusInCall: '通話中',
      },
      pv: {
        label: '累計のPV数：',
      },
      public: '公開中',
      unpublic: '非公開',
      createdAt: '制作日',
    },
    relatedOffersList: {
      header: '関連サービス',
    },
    reviewCarousel: {
      showMore: 'すべて',
    },
    soundRecorder: {
      deleteAlert: {
        title: '録音データを削除しますか？',
      },
    },
  },
  navigation: {
    home: '検索',
    preOfferChatList: '質問履歴',
    callHistoryList: '申込履歴',
    offers: '提供',
    myPage: 'マイページ',
    myProfile: 'プロフィール',
    likedService: 'お気に入り',
    blockedUsers: 'ブロック',
    notifications: 'お知らせ',
    review: 'レビュー',
    myAccount: 'アカウント設定',
    myAccountEmail: 'メールアドレス設定',
    myAccountPassword: 'パスワード設定',
    homeFilter: 'フィルター',
    offerEdit: '提供サービス',
    callRequest: 'トーク申込',
    callHistory: 'トーク申込',
    salesHistory: '売上管理',
    withdrawal: '振込申請',
    withdrawalRequest: '振込申請',
    withdrawalDescription: '振込申請手数料について',
    balance: '残高・履歴',
    owner: '販売者',
    myAddress: '居住地情報',
    creditCard: 'クレジットカード情報',
    identification: '本人確認',
    privacyPolicy: 'プライバシーポリシー',
    terms: '利用規約',
  },
  screens: {
    authLanding: {
      btnSignUp: '新規登録',
      btnSignIn: 'ログイン',
    },
    authPasswordReset: {
      confirmLayout: {
        label:
          '入力されたメールアドレス宛に確認用のコードを送信しました。\nメールに記載された確認コードを以下に入力し、次のステップに進んでください。',
        inputCodePlaceholder: '確認コード',
        inputPasswordPlaceholder: '新しいパスワード(6文字以上の半角英数字,記号)',
        inputPasswordConfirmPlaceholder: '確認用にもう一度入力',
        inputCodelValidationRequire: '確認コードを入力してください',
        inputPasswordValidationRequire: 'パスワードを入力してください',
        inputPasswordConfirmValidationRequire: '確認用パスワードを入力してください',
        inputPasswordConfirmValidationMismatch: 'パスワードが一致しませんでした',
        btnConfirm: '次へ',
        processedDialogTitle: 'パスワードの設定が完了しました。',
        processedDialogBtnOK: 'OK',
        errorCodeMismatchException: '確認コードが正しくありません',
        errorInvalidParameterException: 'パスワードのフォーマットが正しくありません',
      },
      requestLayout: {
        label:
          'パスワードをリセットするための確認コードを送信します。\n登録済みのメールアドレスを入力してください。',
        inputEmailPlaceholder: 'メールアドレス',
        inputEmailValidationRequire: 'メールアドレスを入力してください',
        inputEmailValidationFormat: 'メールアドレスが正しくありません',
        btnReset: '確認コードを送信する',
        errorNotAuthorizedException:
          'こちらのユーザーは停止されているため、サービスをご利用いただけません',
        errorUserNotFoundException:
          'ユーザーが登録されていません。入力に間違いがないか再度ご確認ください',
      },
    },
    authSignIn: {
      navigationBarSignInTitle: 'ログイン',
      inputEmailPlaceholder: 'メールアドレス',
      inputPasswordPlaceholder: 'パスワード',
      inputEmailValidationRequire: 'メールアドレスを入力してください',
      inputEmailValidationFormat: 'メールアドレスが正しくありません',
      inputPasswordValidationRequire: 'パスワードを入力してください',
      btnSignIn: 'ログインする',
      btnRestore: 'パスワードを忘れた方はこちら',
      navigationBarPasswordResetTitle: 'パスワードリセット',
      errorNotAuthorizedException:
        'パスワードが異なっています。半角入力モードでCapsLockキーの状態にご注意いただき、正しくご入力ください',
    },
    authSignupConfirm: {
      label:
        '入力されたメールアドレス宛に確認用のコードを送信しました。\nメールに記載された確認コードを以下に入力し、次のステップに進んでください。',
      inputCodePlaceholder: '確認コード',
      inputCodeValidationRequire: '確認コードを入力してください',
      btnReset: '新規登録する',
      confirmSuccessAlertTitle: '新規登録が完了しました。',
      confirmSuccessAlertDescription: 'さっそくログインして始めてみましょう。',
      errorCodeMismatchException: '確認コードが正しくありません',
    },
    authSignup: {
      navigationBarSignUpTitle: '新規登録',
      inputNicknamePlaceholder: 'ニックネーム',
      inputEmailPlaceholder: 'メールアドレス',
      inputPasswordPlaceholder: 'パスワード',
      inputPasswordConfirmPlaceholder: 'パスワード確認',
      inputNicknameValidationRequire: 'ニックネームを入力してください',
      inputEmailValidationRequire: 'メールアドレスを入力してください',
      inputEmailValidationFormat: 'メールアドレスが正しくありません',
      inputPasswordValidationRequire: 'パスワードを入力してください',
      inputPasswordConfirmValidationRequire: '確認用パスワードを入力してください',
      inputPasswordValidationMismatch: 'パスワードが一致しませんでした',
      btnSignUpSendCode: '確認コードを取得する',
      btnSignUpCancel: 'キャンセルする',
      navigationBarConfirmTitle: '確認コード',
      errorUsernameExistsException:
        'ユーザーが既に存在しています。ログイン画面からログインしてください',
      errorInvalidParameterException: 'パスワードのフォーマットが正しくありません',
    },
    balance: {
      buyPointAlertSuccessTitle: 'ポイント購入が完了しました。',
      balance: '残高',
      cardDetail: 'カード情報',
      usageHistory: '利用履歴',
      buyPoint: 'ポイント購入',
      addCreditCard: 'クレジットカード登録',
      buyPointConfirmAlertTitle: '購入の確認',
      buyPointConfirmAlertDescription: '分を購入してよろしいですか？',
    },
    blockedUsers: {
      notFound: {
        text: 'ブロックしたユーザーは\nいません｡',
      },
      unblock: 'ブロックを解除する',
    },
    call: {
      talkActions: {
        new: 'NEW',
      },
      actions: {
        hide: '非表示',
        abort: '取り消し',
        sendAndFinish: '送信して終了',
        reject: '辞退する',
        talk: 'トーク開始',
        finish: '終了',
      },
      banner: {
        waitingAnswerStatus: 'トーク申込の返答待ち',
        waitingAnswerLabel: '最大待ち時間',
        answerRequiredStatus: '返答までの待ち時間',
        answerRequiredLabel: '最大待ち時間',
        waitingTalkConnectionBySenderStatus: '相手がトーク申込を受け付けました',
        waitingTalkConnectionByReceiverStatus: '相手の応答を待機中',
        talkTimeStatus: '通話時間',
        talkTimeLabel: '最大通話可能時間',
        talkRemainStatus: '残り時間',
      },
      comment: {
        placeholder: 'コメント（任意）',
        comment: 'コメント',
      },
      talkBlock: {
        description:
          '今回のトークに問題がある場合は、トーク開始後1分以内に終了してください。\n1分以内にトークを終了すると料金がかかりません。',
      },
      waitingAnswerBlock: {
        description:
          '1分以内のトークはお試し時間のため料金がかかりません｡\n軽くトークをして問題がないかどうかを判断しましょう｡',
      },
      navigationBarTitle: 'トーク',
      callOver: '予期せぬ不具合でトークできませんでした',
      service: 'サービス',
      abortAlertTitle: '申込辞退の確認',
      abortAlertDescription: 'さんからのトーク申込を辞退しますか？',
    },
    callHistory: {
      requestOfferAlertSuccessTitle: 'トーク申込の再依頼',
      requestOfferAlertSuccessDescription: 'もういちどトーク申込してもらうよう通知を出しました。',
      service: 'サービス',
      price: '単価',
      history: '履歴',
      requestStarted: 'トーク申込開始',
      requestCanceled: 'トーク申込キャンセル',
      callStarted: 'トーク開始',
      callCanceled: 'トークキャンセル',
      callFinished: 'トーク完了',
      requestExpired: 'トーク申込タイムアウト',
      cancelReason: 'キャンセルの理由',
      review: 'レビュー',
      openReview: '評価する',
      chat: 'チャット',
      openReoffer: '再トーク申込する',
      requestReoffer: 'トーク申込を再依頼',
      requestReofferAlert: 'トーク申込を再依頼しますか？',
    },
    callHistoryList: {
      callHistoryItem: {
        activeCall: '申込中',
        waitingForReview: '評価待ち',
      },
      navigationBarTopTitle: '履歴',
      tabAll: '全て',
      tabSent: '申込した',
      tabReceived: '申込された',
      notFound: 'トーク申込はありません',
    },
    callRequest: {
      price: '単価',
      balanceExpired: 'ポイント残高不足',
      maxTalkTime: '最大トーク時間',
      waitingTime: '待ち時間',
      commentPlaceholder: 'コメント（任意）',
      comment: 'コメント',
      service: 'サービス',
      aboutTalk: 'トークについて',
      send: '送信',
      buyPoints: 'ポイント購入',
    },
    creditCard: {
      creditCard: 'クレジットカード',
      register: '登録',
    },
    home: {
      notFound: {
        text: 'サービスが見つかりませんでした',
        description: '違う名称、カテゴリー名、\n地名など他のキーワードで検索してみてください。',
      },
      searchBar: {
        search: '検索',
        placeholder: 'サービス、カテゴリー、地名など',
      },
      navigationBarTopTitle: 'ホーム',
      recommendations: 'おすすめ',
      searchResults: '検索結果',
    },
    homeFilter: {
      userStatus: 'ステータス',
      category: 'カテゴリー',
      gender: '性別',
      age: '年齢',
      area: 'エリア',
      order: '順番',
      reset: 'リセット',
    },
    identification: {
      phone: {
        codeSentAlertTitle: '確認コードを送信しました',
        phone: '電話番号',
        phonePlaceholder: '電話番号を入力してください',
        code: '確認コード',
        codePlaceholder: '確認コードを入力してください',
        codeSend: '確認コードを送信する',
        codeResend: '届いてませんか？\nもう一度確認コードを送信する',
      },
      removeImageAlertTitle: '写真を削除しますか？',
      emptyImagesAlertTitle: '写真は1枚以上アップロードしてください。',
      imageUpload: '写真をアップロード',
    },
    likedServies: {
      notFound: {
        text: 'お気に入りはまだありません｡',
      },
    },
    myAccount: {
      email: 'メールアドレス',
      emailDescription:
        '※メールアドレスを変更すると、確認コードが送信されますので、届いた確認コードをこの後のコード入力画面に入力すると変更が完了します。',
      password: 'パスワード',
    },
    myAccountEmail: {
      confirm: {
        description:
          '入力されたメールアドレス宛に確認用のコードを送信しました。\nメールに記載された確認コードを以下に入力し、次のステップに進んでください。',
        code: '確認コード',
      },
      request: {
        emailValidationRequire: '必須',
        emailValidationFormat: 'メールアドレス形式が正しくありません',
        emailValidationMatch: '現在と異なるメールアドレスを入力してください',
        email: 'メールアドレス',
        emailDescription:
          '※メールアドレスを変更すると、確認コードが送信されますので、届いた確認コードをこの後のコード入力画面に入力すると変更が完了します。',
      },
      emailChangeAlertTitle: 'メールアドレスの変更が完了しました',
    },
    myAccountPassword: {
      oldPasswordValidationRequired: '必須',
      passwordValidationRequired: '必須',
      passwordConfirmValidationRequired: '必須',
      passwordConfirmValidationMismatch: 'パスワードが一致しませんでした',
      password: 'パスワード',
      oldPassword: '現在のパスワード',
      newPassword: '新しいパスワード(6文字以上の半角英数字,記号)',
      newPasswordConfirm: '新しいパスワード（確認）',
    },
    myAddress: {
      postnumberValidationRequired: '郵便番号を入力してください',
      postnumberValidationFormat: '正しい郵便番号を入力してください',
      prefectureValidationRequired: '都道府県を入力してください',
      cityValidationRequired: '住所1を入力してください',
      addressValidationRequired: '住所2を入力してください',
      postnumber: '郵便番号',
      postnumberPlaceholder: '例）1234567',
      prefecture: '都道府県',
      city: '住所１',
      address: '住所２',
      addressPlaceholder: '例）1-2-3',
      address2: '物件名（任意）',
      address2Placeholder: '例）青葉ビル101',
    },
    myPage: {
      navigationBarTopTitle: 'マイページ',
      logoutAlertTitle: 'ログアウト',
      logoutAlertDescription: 'ログアウトしますか？',
      logoutAlertAction: 'ログアウトする',
      profile: 'プロフィール',
      balance: '残高',
      favorites: 'お気に入り',
      blocks: 'ブロック',
      salerReview: '販売者からの評価',
      salerReviewTitle: '販売者からの評価',
      salerReviewNotFound: '販売者からの評価はありません｡',
      buyerReview: '購入者からの評価',
      buyerReviewTitle: '購入者からの評価',
      buyerReviewNotFound: '購入者からの評価はありません｡',
      salesHistory: '売上管理',
      myAccount: 'アカウント設定',
      notifications: 'お知らせ',
      feedback: 'お問い合わせ・バグ報告',
      logout: 'ログアウト',
      removeAccountBtn: '退会する',
      removeAccountAlertTitle: '退会',
      removeAccountAlertMessage: '退会しますか？',
      removeAccountAlertAction: '退会する',
      privacyPolicy: 'プライバシーポリシー',
      terms: '利用規約',
    },
    myProfile: {
      aboutProfileControl: {
        description:
          'こんにちは、おおくんと申します。\n現在ネット系の会社で在宅で会社員をしています。\n丁寧に対応いたしますので、お気軽によろしくお願いいたします。',
        title: 'プロフィール',
        placeholder:
          'こんにちは、おおくんと申します。\n現在ネット系の会社で在宅で会社員をしています。\n丁寧に対応いたしますので、お気軽によろしくお願いいたします。',
      },
      aboutTalkControl: {
        description: '平日：20時～23時\n土日祝：13時～23時\nがつながりやすいです。',
        title: 'トークしやすい時間帯',
        placeholder: '平日：20時～23時\n土日祝：13時～23時\nがつながりやすいです。',
      },
      address: {
        title: '居住地情報',
        helper: '都道府県のみ公開',
      },
      birthday: {
        title: '生年月日',
        helper: '年代のみ公開',
      },
      descriptionControl: {
        description: '■自己PRや今までの経験など\n■職業\n■性格\n■免許・資格\n■趣味・特技',
        title: '情報',
        placeholder: '■自己PRや今までの経験など\n■職業\n■性格\n■免許・資格\n■趣味・特技',
      },
      genderControl: {
        title: '性別',
      },
      identification: {
        title: '本人確認の手続きをする',
        rejected: '本人確認は拒否されました',
        processed: '処理中です',
        approved: '本人確認済み',
      },
      nameValidationRequired: 'ニックネームを入力してください',
      generalSection: '基本情報',
      nickname: 'ニックネーム',
      nicknamePlaceholder: 'ニックネームを入力してください',
      nicknameValidationExist: '入力されたニックネームはすでに存在しています',
      fullname: '本名',
      fullnamePlaceholder: '本名を入力してください',
      fullnameHelper: '非公開',
      identificationSection: '本人確認',
      profileSection: 'プロフィール',
      aboutTalkSection: 'トークしやすい時間帯',
      descriptionSection: '情報',
      soundSection: '音声録音',
    },
    offer: {
      averageTimeRow: {
        text: '平均トーク時間',
      },
      usageCountText: '累計トーク数',
      usageCountSufix: '回',
      review: 'レビュー',
      openPreOfferChat: '質問する',
      openOffer: 'トーク申込へ',
      block: 'ブロックする',
    },
    offerEdit: {
      name: 'サービス名',
      namePlaceholder: '・サービス名は最大２５６文字まで\n・一覧表示では３２文字に制限されます',
      category: 'カテゴリー',
      price: '単価',
      publish: '公開状態',
      publishActive: '公開',
      publishInactive: '非公開',
      description: '説明文',
      imagesValidationRequired: '画像をアップロードしてください',
      nameValidationRequired: 'サービス名を入力してください',
      descriptionValidationRequired: '説明文を入力してください',
      categoryValidationRequired: 'カテゴリーを選択してください',
      priceValidationRequired: '単価を入力してください',
      serviceSection: 'サービス概要',
      descriptionSection: '説明',
    },
    offers: {
      notFound: {
        text: '提供サービスはありません｡',
        description: '下記ボタンから新規提供サービスを\n登録してみましょう！',
        action: 'サービスを制作する',
      },
      navigationBarTopTitle: '提供サービス',
    },
    owner: {
      blockAlertTitle: 'ブロックしました',
      createdAt: '登録日：',
      aboutTalk: 'トークしやすい時間帯',
      aboutProfile: 'プロフィール',
      description: '情報',
      review: 'レビュー',
      reviewNotFound: '評価はありません｡',
      block: 'ブロックする',
    },
    preOfferChatList: {
      navigationBarTopTitle: '履歴',
      tabAll: '全て',
      tabSent: '質問した',
      tabReceived: '質問された',
      notFound: '質問はありません',
    },
    review: {
      commentInput: {
        placeholder: 'コメント（任意）',
      },
      ratingSection: '評価',
      post: '投稿する',
    },
    reviewByOffer: {
      notFound: {
        text: '購入者からの評価はありません｡',
      },
    },
    reviewByOfferToUser: {
      notFound: {
        text: '購入者からの評価はありません｡',
      },
    },
    salesHistory: {
      notFound: {
        text: '売上・振込履歴はありません｡',
      },
      saleRow: {
        withdrawalRequest: '処理前',
        withdrawalProcessing: '処理中',
        withdrawalApproved: '振込済',
        withdrawalError: 'エラー',
        withdrawalReject: '拒否',
      },
      amountAlertTitle: '振込申請',
      amountAlertDescription: '500円以上から振込申請が可能です。',
      identificationAlertTitle:
        '振込申請を行うにはマイページのプロフィールから本人確認手続きを完了させてください',
      sales: '現在の売上金',
      limit: '※振込申請期限：',
      withdrawal: '振込申請',
      salesAmountDescription: '※¥500から可能',
      historySection: '利用履歴',
    },
    user: {
      blockAlertTitle: 'ブロックしました',
      createdAt: '登録日：',
      aboutTalk: 'トークしやすい時間帯',
      aboutProfile: 'プロフィール',
      description: '情報',
      review: 'レビュー',
      reviewNotFound: '評価はありません｡',
      block: 'ブロックする',
    },
    withdrawal: {
      typeUndefined: '未定',
      typeRequest: '処理前',
      typeProcessing: '処理中',
      typeApproved: '振込済',
      typeRejected: 'キャンセル',
      typeError: 'エラー',
      status: 'ステータス',
      createdAt: '申請日時',
      requestAmount: '申請金額',
      fee: '振込手数料',
      transferAmount: '振込金額',
      systemFee: '処理手数料',
      bankSection: '振込先',
      bankCode: '銀行コード',
      bankName: '銀行名',
      branchCode: '支店コード',
      branchName: '支店名',
      accountType: '口座種別',
      accountNumber: '口座番号',
      accountHolder: '口座名義人（カナ）',
    },
    withdrawalRequest: {
      amountControl: {
        text: '申請金額',
      },
      bankControl: {
        text: '銀行',
        helper:
          '促音（ッ）・拗音（ャ、ュ、ョ）はそれぞれ「ツ、ヤ、ユ、ヨ」にして検索してください。',
      },
      bankBranchControl: {
        text: '支店',
        helper:
          '促音（ッ）・拗音（ャ、ュ、ョ）はそれぞれ「ツ、ヤ、ユ、ヨ」にして検索してください。',
      },
      accountTypeControl: {
        text: '口座種別',
      },
      accountNumberControl: {
        text: '口座番号',
        placeholder: '(必須)',
      },
      accountHolderControl: {
        text: '口座名義人（カナ・空白なし）',
        placeholder: '(必須)',
      },
      amountValidationRequired: '申請金額を入力してください',
      amountValidationUnexpeced: '申請金額が正しくありません',
      bankValidationRequired: '銀行を入力してください',
      branchValidationRequired: '支店を入力してください',
      accountTypeValidationRequired: '口座種別を入力してください',
      accountNumberValidationRequired: '口座番号を入力してください',
      accountHolderValidationRequired: '口座名義人を入力してください',
      accountHolderValidationFormat: 'カタカナのみ入力してください',
      doneAlertTitle: '振込申請が完了しました。',
      sales: '現在の売上金',
      description:
        '※振込申請時に手数料が発生致します｡\n詳しい手数料についてはこちらをご確認ください｡',
      transferSection: '振込先',
      process: '申請する',
    },
  },
};

export default local;
